import { gsap, ScrollTrigger } from "./globals.js";
document.addEventListener("DOMContentLoaded", () => {
	// STATS TICKER
	const statsWrap = document.querySelector(".stats__wrap");

	if (statsWrap) {
		// Set fixed width to prevent layout shifts during animation
		document.querySelectorAll(".stat__num").forEach(el => {
		  el.style.width = el.offsetWidth + "px";
		});

		document.querySelectorAll(".stat__num .num").forEach(el => {
		  const endValue = parseFloat(el.textContent.replace(/,/g, ""));
		  const isInt = Number.isInteger(endValue);
		  const counter = { val: 0 };

		  gsap.to(counter, {
		    val: endValue,
		    ease: "none",
		    scrollTrigger: {
		      trigger: statsWrap,
		      start: "top bottom",
		      end: "center center",
		      scrub: 2,
		      once: true,
		    },
		    onUpdate: () => {
		      el.textContent = isInt
		        ? Math.floor(counter.val).toLocaleString()
		        : counter.val.toLocaleString(undefined, { minimumFractionDigits: 2 });
		    }
		  });
		});
	}
});
